import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../ui/Logo';
import Button from '../ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Features',
    href: '/features'
  }, {
    name: 'Pricing',
    href: '/pricing'
  }, {
    name: 'About Us',
    href: '/about'
  }, {
    name: 'Contact Us',
    href: '/contact'
  }, {
    name: 'FAQs',
    href: '/faq'
  }, {
    name: 'Privacy Policy',
    href: '/privacy'
  }, {
    name: 'Terms & Conditions',
    href: '/terms'
  }];
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <header className="bg-white shadow-sm" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="flex justify-between h-16" data-id="element-81">
          <div className="flex items-center" data-id="element-82">
            <Logo data-id="element-83" />
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-84">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`font-medium ${isActive(item.href) ? 'text-navy border-b-2 border-sky-blue' : 'text-dark hover:text-navy'}`} aria-current={isActive(item.href) ? 'page' : undefined} data-id="element-85">
                {item.name}
              </Link>)}
            <Button href="/contact" variant="primary" data-id="element-86">
              Get Started
            </Button>
          </nav>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-87">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-navy hover:text-navy hover:bg-light-grey focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" aria-controls="mobile-menu" aria-expanded="false" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-88">
              <span className="sr-only" data-id="element-89">Open main menu</span>
              {mobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-90" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-91" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden" id="mobile-menu" data-id="element-92">
          <div className="pt-2 pb-3 space-y-1 px-4 sm:px-6 lg:px-8" data-id="element-93">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`block py-2 font-medium ${isActive(item.href) ? 'text-navy bg-light-grey rounded-md' : 'text-dark hover:text-navy hover:bg-light-grey/50 rounded-md'}`} aria-current={isActive(item.href) ? 'page' : undefined} onClick={() => setMobileMenuOpen(false)} data-id="element-94">
                {item.name}
              </Link>)}
            <div className="pt-3" data-id="element-95">
              <Button href="/contact" variant="primary" className="w-full" data-id="element-96">
                Get Started
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}